(
    function (skyward, $, undefined)
    {
        skyward.printreceipt = skyward.printreceipt || {};

        var printPaymentBundleReceiptFromList = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'PaymentBundle', 'DisplayReceiptFromList', $(this).data('id'));
        };

        var printPaymentBundleReceiptForReceiptPrinterFromList = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'PaymentBundle', 'DisplayReceiptPrinterReceiptFromList', $(this).data('id'));
        };

        var printPaymentReceiptFromList = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptFromList', $(this).data('paymentId'));
        };

        var printPaymentReceiptForReceiptPrinterFromList = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptPrinterReceiptFromList', $(this).data('paymentId'));
        };

        var printPaymentReceiptFromStudentProfile = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptFromStudentProfile', $(this).data('paymentId'));
        };

        var printPaymentReceiptFromStudentAccess = function () {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptFromStudentAccess', $(this).data('paymentId'));
        };

        var printPaymentReceiptFromFamilyAccess = function () {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptFromFamilyAccess', $(this).data('paymentId'));
        };

        // Event handlers
        var events =
        {
            "printPaymentBundleReceiptFromList": printPaymentBundleReceiptFromList,
            "printPaymentBundleReceiptForReceiptPrinterFromList": printPaymentBundleReceiptForReceiptPrinterFromList,
            "printPaymentReceiptFromList": printPaymentReceiptFromList,
            "printPaymentReceiptForReceiptPrinterFromList": printPaymentReceiptForReceiptPrinterFromList,
            "printPaymentReceiptFromStudentProfile": printPaymentReceiptFromStudentProfile,
            "printPaymentReceiptFromStudentAccess": printPaymentReceiptFromStudentAccess,
            "printPaymentReceiptFromFamilyAccess": printPaymentReceiptFromFamilyAccess
        };
        skyward.events.registerEvents("printreceipt", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
)